<template>
    <div>
        <CList :pConfigList="ConfigList" :segurity="segurity">
            <template slot="bodyForm">
                <CLoader :pConfigLoad="ConfigLoad">
                    <template slot="BodyFormLoad">
                        <form id="FormPresentacion" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                                <label for="Unidad">Unidad</label>
                                                <select @change="ActualizarCmbSubunidad()" v-model="objMaterialPresentacion.IdUnidadMaterial" class="form-control-search form-select" id="IdUnidadMaterial">
                                                    <option value="">Seleccione una Unidad</option>
                                                    <option v-for="(item, index) in Unidades" :key="index" :value="item.IdUnidadMaterial">{{item.Nombre}}</option>
                                                </select>
										        <CValidation v-if="this.errorvalidacion.IdUnidadMaterial" :Mensaje="'*'+errorvalidacion.IdUnidadMaterial[0]"/>
                                            </div>

                                            <div class="col-12 col-sm-12 col-md-6 col-lg-6">
                                                <label for="SubUnidad">Sub Unidad</label>
                                                <select v-model="objMaterialPresentacion.IdSubUnidadMaterial" class="form-control-search form-select" id="IdSubUnidadMaterial">
                                                    <option value="">Seleccione una Sub Unidad</option>
                                                    <option v-for="(item, index) in SubUnidades" :key="index" :value="item.IdSubUnidadMaterial">{{item.Cantidad + ' ' + item.SubUnidad}}</option>
                                                </select>
										        <CValidation v-if="this.errorvalidacion.IdSubUnidadMaterial" :Mensaje="'*'+errorvalidacion.IdSubUnidadMaterial[0]"/>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                                                <button @click="AbreModal" type="button" class="btn btn-primary"><i class="fa fa-plus"></i> Agregar Proveedor</button>
                                            </div>
                                        </div>
                                        
                                        <div class="table-responsive">
                                            <table class="table align-items-center mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Precio Base</th>
                                                        <th>Proveedor</th>
                                                        <th>Razón Social</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody v-show="ProveedoresSeleccionados.length>0">
                                                    <tr v-for="(item,index) in ProveedoresSeleccionados" :key="index">
                                                        <td class="w-10">
                                                            <input v-model="item.Costo" type="text" class="form-control" @input="$number_decimal($event,item,'Costo')">
                                                            <CValidation v-if="errorvalidacion[item.IdProveedor]" :Mensaje="'*'+errorvalidacion[item.IdProveedor].Costo[0]"/>
                                                        </td>
                                                        <td class="w-20">{{ item.NombreComercial }}</td>
                                                        <td class="w-20">{{ item.RazonSocial }}</td>
                                                        <td class="w-5">
                                                            <button type="button" class="btn btn-link text-danger text-gradient px-3 mb-0" @click="EliminarProveedor(item.IdProveedor)">
                                                                <i class="far fa-trash-alt me-2" aria-hidden="true"></i> Eliminar
                                                            </button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <CValidation v-if="this.errorvalidacion.Proveedores" :Mensaje="'*'+errorvalidacion.Proveedores[0]"/>
                                        </div>
                                        <CBtnSave :poBtnSave="oBtnSave" />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </template>
                </CLoader>
            </template>
        </CList>
        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSaveModal">
            <template slot="Form">
                <FormModal :poBtnSave="oBtnSaveModal" :objProveedoresSeleccionados="ProveedoresSeleccionados"></FormModal>
            </template>
        </CModal>
    </div>
</template>
<script>
import FormModal from '@/views/modulos/almacen/presentacion/ProveedorModal.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionPresentacion';
const EmitEjecuta2 = 'seccionProveedores';
export default {
    name: 'FormPresentacion',
    props: ['Id','Obj'],
    components:{
        FormModal
    },
    data(){
        return{
            ConfigList:{
                Title: 'Formulario de Presentaciones',
                IsModal: false,
                BtnReturnShow: true,
                BtnNewShow: false,
                ShowFiltros: false,
                ShowPaginador: false,
                TypeBody: 'Form',
				TitleFirst: this.Obj.Nombre,
				EmitSeccion: EmitEjecuta,
            },
            ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            ConfigModal:{
                ModalTitle: "Asignar Proveedor",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta2,
                ModalSize:'xl',
                ShowFooter:false
            },
			oBtnSave:{
                Toast: 0,
                IsModal: false,
                DisableBtn: false,
                ReturnRoute: 'presentacion',
                EmitSeccion: EmitEjecuta,
                ShowBtnCancel:false
            },
            oBtnSaveModal: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
                TxtBtnSave:'Asignar'
            },
            objMaterialPresentacion: {
				IdMaterialPresentacion: 0,
				IdMaterial: 0,
				IdUnidadMaterial: 0,
				IdSubUnidadMaterial: 0,
				Proveedores:[]
            },
            segurity: {},
			masks: { input: 'YYYY-MM-DD' }, // quitar sino lleva fecha 
            errorvalidacion: [],
            errorvalidacion2: [],
			Emit: EmitEjecuta,
            // PROPIO
            Unidades:[],
            SubUnidades:[],
            ArraySubunidades:[],
            ProveedoresSeleccionados:[],
            ListaFiltro:[],
        }
    },
    methods: {
        async Guardar(){
            this.errorvalidacion = [];
            this.oBtnSave.Toast = 0; 
            this.oBtnSave.DisableBtn = true;
            this.objMaterialPresentacion.Proveedores=JSON.stringify(this.ProveedoresSeleccionados);
            if (this.objMaterialPresentacion.IdMaterialPresentacion==0) {
                await this.$http.post("/materialespresentacion",this.objMaterialPresentacion
                ).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch((err)=>{
                    this.EjecutaConError(err);
                })
            }
            else{
                await this.$http.put("/materialespresentacion/"+this.objMaterialPresentacion.IdMaterialPresentacion,this.objMaterialPresentacion
                ).then((res)=>{
                    this.EjecutaConExito(res);
                }).catch((err)=>{
                    this.EjecutaConError(err);
                })
            }
        },
        EjecutaConExito(res){
            this.oBtnSave.DisableBtn = false;  
            this.bus.$emit('RunAlerts_'+this.Emit,1);
            this.Regresar();
        },
        EjecutaConError(err){
            this.oBtnSave.DisableBtn = false;
            this.objMaterialPresentacion.IdMaterialPresentacion=err.response.data.id;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.oBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
        Recuperar(){
            this.$http.get('materialespresentacion/'+this.Id
            ).then((res)=>{
                this.objMaterialPresentacion=res.data.data;
                this.RecuperarProveedores();
            })
        },
        Limpiar(){
            this.objMaterialPresentacion={
                IdMaterialPresentacion: 0,
				IdMaterial: 0,
				IdUnidadMaterial: "",
				IdSubUnidadMaterial: "",
				Proveedores:[]
            };
            this.errorvalidacion = [];
            this.ProveedoresSeleccionados=[];
        },
        Regresar(){
            this.$router.push({name:this.oBtnSave.ReturnRoute,params:{IdMaterial:this.objMaterialPresentacion.IdMaterial,Nombre:this.Obj.Nombre}});
        },
        ListaUnidades(){
            this.$http.get('unidadMateriales/simple'
            ).then((res)=>{
                this.Unidades=res.data.data;
            })
        },
        ActualizarCmbSubunidad(){
            this.objMaterialPresentacion.IdSubUnidadMaterial="";
            this.FilterComboSubunidades();
        },
        GetArraySubUnidades(){
            this.$http.get('subUnidadesMaterial/simple',
            ).then((res)=>{
                this.ArraySubunidades=res.data.data;
            }).catch(err => console.error(err)
            );
        },
        FilterComboSubunidades(){
            this.SubUnidades=[];
            this.SubUnidades=this.ArraySubunidades.filter((elem)=> elem.IdUnidadMaterial == this.objMaterialPresentacion.IdUnidadMaterial)
        },
        AbreModal(){
            this.bus.$emit('NewModal_'+this.ConfigModal.EmitSeccion,0,this.objMaterialPresentacion);
            // this.bus.$emit('Recovery_'+this.ConfigModal.EmitSeccion,0);
        },
        AniadirProveedor(item){
            this.ProveedoresSeleccionados.push(item);
            this.bus.$emit('CloseModal_'+this.ConfigModal.EmitSeccion);
        },
        EliminarProveedor(index){
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    let IndiceEliminar=this.ProveedoresSeleccionados.findIndex((element)=>element.IdProveedor==index);
                    this.ProveedoresSeleccionados.splice(IndiceEliminar,1);
                } 
            });
        },
        RecuperarProveedores(){
            this.$http.get('materialespresentacionproveedor',{
                params:{
                    IdMaterialPresentacion:this.Id
                }
            }).then((res)=>{
                this.ProveedoresSeleccionados=res.data.data;
                this.ProveedoresSeleccionados.map((element)=>{
                    element.NombreComercial=element.proveedor.NombreComercial;
                    element.RazonSocial=element.proveedor.RazonSocial;
                    this.FilterComboSubunidades();
                })
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            })
        },
    },
    created() {
        this.oBtnSave.Toast = 0;
        this.ConfigLoad.ShowLoader = true;

        this.bus.$off('EmitReturn');
        this.bus.$off('Save_'+this.Emit);

        this.bus.$off('SeleccionarProveedor');

        // this.bus.$off('TraerComisionesSeleccionadas');
    },
    mounted()
    {
		this.oBtnSave.DisableBtn = false;
        this.Limpiar();
        this.ListaUnidades();
        this.GetArraySubUnidades();
        this.objMaterialPresentacion.IdMaterial=this.Obj.IdMaterial;
        
        if(this.Id!='') 
        {
            // this.objBancoImagen.IdBancoImagen = this.Id;
            this.Recuperar();
            // this.RecuperarComisiones(this.objBancoImagen.IdBancoImagen);
        }
		else
		{
			this.ConfigLoad.ShowLoader = false;
		}

        this.bus.$on('Save_'+this.ConfigList.EmitSeccion,()=>
        {
            // let Categ = JSON.parse(sessionStorage.getItem('objCategoriaGaleria'));
            // this.objBancoImagen.IdCategoriaGaleria = Categ.IdCategoriaGaleria;
            this.Guardar();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

        this.bus.$on('SeleccionarProveedor',(item)=>{
            this.AniadirProveedor(item);
        });

        // this.bus.$on('TraerComisionesSeleccionadas',(ComisionesSeleccionadas)=>{
            // this.objBancoImagen.ComisionesxBancoImagen=ComisionesSeleccionadas;
        // });
        if (this.Obj.pListaFiltro!=undefined) {
            this.ListaFiltro=this.Obj.pListaFiltro;
        }

    },
}
</script>